module.exports = __webpack_public_path__ + "static/6305-woodrose-26-c308bd93031c4772355f4e197b549f2d.jpg";